const SearchedMyAppsList = ({ appDataList, selectedApp, onClickSelectApp }) => {
  return (
    <>
      {appDataList && (
        <div className="amanager-result store-wrap">
          <div className="store">
            <h2 className="chart-tit">APP STORE</h2>
            {appDataList?.apple?.length > 0 ? (
              <ul className="manager-list">
                {appDataList.apple.map((appObj, index) => (
                  <li key={index}>
                    <div className="manager-list-img">
                      <img src={appObj.icon} alt="" />
                    </div>
                    <div className="manager-list-txt">
                      <span className="manager-list-tit">{appObj.title}</span>
                      <span className="manager-list-dsc">{appObj.developer}</span>
                    </div>
                    <span className="manager-list-chk">
                      <input
                        type="checkbox"
                        className="ipt-check"
                        id={`checked-apple-${index}`}
                        checked={
                          appObj.appId === selectedApp?.appId && appObj.provider_type === selectedApp?.provider_type
                            ? true
                            : false
                        }
                        onChange={() => onClickSelectApp(appObj)}
                      />
                      <label htmlFor={`checked-apple-${index}`}>
                        <span className="blind">선택</span>
                      </label>
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="manager-noresult">There are no apps that match the criteria</p>
            )}
          </div>

          <div className="store">
            <h2 className="chart-tit">PLAY STORE</h2>
            {appDataList?.google?.length > 0 ? (
              <ul className="manager-list">
                {appDataList?.google.map((appObj, index) => (
                  <li key={index}>
                    <div className="manager-list-img">
                      <img src={appObj.icon} alt="" />
                    </div>
                    <div className="manager-list-txt">
                      <span className="manager-list-tit">{appObj.title}</span>
                      <span className="manager-list-dsc">{appObj.developer}</span>
                    </div>
                    <span className="manager-list-chk">
                      <input
                        type="checkbox"
                        className="ipt-check"
                        id={`checked-google-${index}`}
                        checked={
                          appObj.appId === selectedApp?.appId && appObj.provider_type === selectedApp?.provider_type
                            ? true
                            : false
                        }
                        onChange={() => onClickSelectApp(appObj)}
                      />
                      <label htmlFor={`checked-google-${index}`}>
                        <span className="blind">선택</span>
                      </label>
                    </span>
                  </li>
                ))}
              </ul>
            ) : (
              <p className="manager-noresult">There are no apps that match the criteria</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SearchedMyAppsList;
